import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-user-menu',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent {
  @Output() menuItemClicked = new EventEmitter<void>();
  isOpen = signal(false);

  constructor(private authService: AuthService, private router: Router) {}

  get authState() {
    return this.authService.authStateSignal();
  }

  get user() {
    return this.authService.currentUser;
  }

  get isAuthenticated() {
    return this.authService.isAuthenticated;
  }

  toggleMenu() {
    this.isOpen.update((value) => !value);
  }

  closeMenu() {
    this.isOpen.set(false);
  }

  onLogin() {
    this.router.navigate(['/auth/login']);
    this.closeMenu();
    this.menuItemClicked.emit();
  }

  onLogout() {
    this.authService.logout();
    this.closeMenu();
    this.menuItemClicked.emit();
  }

  handleLinkClick(): void {
    this.closeMenu();
    this.menuItemClicked.emit();
  }

  // Obtener iniciales del nombre
  getInitials(name: string): string {
    return name
      .split(' ')
      .map((word) => word.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  }
}
